import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private token: string | null = null;
  private username: string | null = null;
  private password: string | null = null;


  setToken(token: string) {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  setCredentials(username: string, password: string) {
    this.username = username;
    this.password = password;
  }

  getCredentials(): { username: string | null; password: string | null } {
    return { username: this.username, password: this.password };
  }

  isUserLoggedIn(): boolean {
    return this.token !== null && this.username !== null && this.password !== null;
  }





}
